export function HostnameDisplay() {
	return <code className="rounded bg-muted px-1.5 py-0.5 text-sm">{window.location.hostname}</code>;
}
